module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhead4-09714bd2a04fcd00608ff85e586f023b.jpg";